export default __webpack_public_path__ + "static/social-envipe-28239684ef939e5d7998c82f4787c271.png";